window.$ = window.jQuery = require('jquery');

$(document).ready(function () {

    // fix header
    let headerHeightSet = false;
    let headerHeight;

    $(window).on('scroll', function(){
        let header = $('.header'),        
            scroll = $(window).scrollTop();

        if (!headerHeightSet) {
            headerHeight = header.outerHeight(true);
            headerHeightSet = true;
        }
        
        if (scroll >= headerHeight) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }
    });

    // burger menu
    function openMenu(){
        $('body').css({'overflow': 'hidden'});
        $('.js-burger-open').addClass('opened');
        $('.header').addClass('opened');
    }

    function closeMenu(){
        $('body').css({'overflow': ''});
        $('.js-burger-open').removeClass('opened');
        $('.header').removeClass('opened');
    }

    $('.js-burger-open').on('click', function(){
        if($('.header').hasClass('opened')){    
            closeMenu();
        } else {
            openMenu();
        }
        return false;
    });

    $(window).on('resize', function(){
        if ($(window).width() > 1299) {
            closeMenu();
        }
    });

    // scroll to element
    $('a[href^="#"]').on('click', function (event) {
        if($('.header').hasClass('opened')){
            closeMenu();
        }

        let id = $(this).attr("href"),
            offset = $('.header').outerHeight()+48,
            target = $(id).offset().top - offset;

        $('html, body').animate({ scrollTop: target }, 500);

        return false;
    });
});
